export default __webpack_public_path__ + "static/media/LogoHConnectSquareWhite.5f5227d4.svg";